//User Info
export const REQUEST_USER_INFO            = 'REQUEST_USER_INFO';
export const RECEIVE_USER_INFO_ERROR      = 'RECEIVE_USER_INFO_ERROR';
export const RECEIVE_USER_INFO_SUCCESS    = 'RECEIVE_USER_INFO_SUCCESS';
export const USER_LOGOUT                  = 'USER_LOGOUT';

//User Profile
export const REQUEST_USER_PROFILE         = 'REQUEST_USER_PROFILE';
export const RECEIVE_USER_PROFILE_ERROR   = 'RECEIVE_USER_PROFILE_ERROR';
export const RECEIVE_USER_PROFILE_SUCCESS = 'RECEIVE_USER_PROFILE_SUCCESS';

//Templates
export const REQUEST_TEMPLATES            = 'REQUEST_TEMPLATES';
export const RECEIVE_TEMPLATES_ERROR      = 'RECEIVE_TEMPLATES_ERROR';
export const RECEIVE_TEMPLATES_SUCCESS    = 'RECEIVE_TEMPLATES_SUCCESS';

//All Channels
export const REQUEST_CHANNELS             = 'REQUEST_CHANNELS';
export const RECEIVE_CHANNELS_ERROR       = 'RECEIVE_CHANNELS_ERROR';
export const RECEIVE_CHANNELS_SUCCESS     = 'RECEIVE_CHANNELS_SUCCESS';
//All Categories
export const REQUEST_CATEGORIES           = 'REQUEST_CATEGORIES';
export const RECEIVE_CATEGORIES_ERROR     = 'RECEIVE_CATEGORIES_ERROR';
export const RECEIVE_CATEGORIES_SUCCESS   = 'RECEIVE_CATEGORIES_SUCCESS';

//Media Picker 
export const OPEN_MEDIA_PICKER            = 'OPEN_MEDIA_PICKER';
export const CLOSE_MEDIA_PICKER           = 'CLOSE_MEDIA_PICKER';
export const DRAGGING_ASSET               = 'DRAGGING_ASSET';
export const STOP_DRAGGING_ASSET          = 'STOP_DRAGGING_ASSET';
export const RESET_MEDIA_PICKER           = 'RESET_MEDIA_PICKER';
export const INIT_DATA                    = 'INIT_DATA';

export const ADD_SELECTED_ASSET           = 'ADD_SELECTED_ASSET';      
export const ASSIGN_ASSET                 = 'ASSIGN_ASSET';    

//Recent Media       
export const REQUEST_RECENT_MEDIA         = 'REQUEST_RECENT_MEDIA';
export const RECEIVE_RECENT_MEDIA_ERROR   = 'RECEIVE_RECENT_MEDIA_ERROR';
export const RECEIVE_RECENT_MEDIA_SUCCESS = 'RECEIVE_RECENT_MEDIA_SUCCESS';
export const RESET_RECENT_MEDIA           = 'RESET_RECENT_MEDIA';
       
//Active Media       
export const REQUEST_ACTIVE_MEDIA         = 'REQUEST_ACTIVE_MEDIA';
export const RECEIVE_ACTIVE_MEDIA_ERROR   = 'RECEIVE_ACTIVE_MEDIA_ERROR';
export const RECEIVE_ACTIVE_MEDIA_SUCCESS = 'RECEIVE_ACTIVE_MEDIA_SUCCESS';
export const RESET_ACTIVE_MEDIA           = 'RESET_ACTIVE_MEDIA';
       
//Media picker selections       
export const CHANGE_CURR_ASSET_TYPE       = 'CHANGE_CURR_ASSET_TYPE';
export const CHANGE_CURR_CATEGORY         = 'CHANGE_CURR_CATEGORY';
export const CHANGE_CURR_SEARCH           = 'CHANGE_CURR_SEARCH';

//Modal
export const DISPLAY_MODAL                = 'DISPLAY_MODAL';
export const CLOSE_MODAL                  = 'CLOSE_MODAL';



/** UPLOAD */
export const REQUEST_UPLOAD_MEDIA           = 'REQUEST_UPLOAD_MEDIA';
export const RECEIVE_UPLOAD_MEDIA_SUCCESS   = 'RECEIVE_UPLOAD_MEDIA_SUCCESS';
export const RECEIVE_UPLOAD_MEDIA_ERROR     = 'RECEIVE_UPLOAD_MEDIA_ERROR';

export const NO_VALID_FILES                 = 'NO_VALID_FILES';

export const REQUEST_INGEST_MEDIA           = 'REQUEST_INGEST_MEDIA';
export const RECEIVE_INGEST_MEDIA_SUCCESS   = 'RECEIVE_INGEST_MEDIA_SUCCESS';
export const RECEIVE_INGEST_MEDIA_ERROR     = 'RECEIVE_INGEST_MEDIA_ERROR';

export const REQUEST_UPLOADED_FILES         = 'REQUEST_UPLOADED_FILES';
export const RECEIVE_UPLOADED_FILES_SUCCESS = 'RECEIVE_UPLOADED_FILES_SUCCESS';
export const RECEIVE_UPLOADED_FILES_ERROR   = 'RECEIVE_UPLOADED_FILES_ERROR';
export const RESET_UPLOAD                   = 'RESET_UPLOAD';


/* Smart Canvas Overlay */
export const OPEN_SMART_CANVAS              = 'OPEN_SMART_CANVAS';
export const CLOSE_SMART_CANVAS             = 'CLOSE_SMART_CANVAS';
export const OPEN_INSTANCE                  = 'OPEN_INSTANCE';



